import React, { useState, useEffect } from 'react';

const ArticleFeatured = () => {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  // Use useEffect hook to fetch articles from the JSON file.
  useEffect(() => {
    fetch('/articles.json')
      .then(res => res.json())
      .then(json => setArticles(json))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  return (
    <div>
      {loading
        ? <p>Loading articles...</p>
        : articles.map(article => (
          <article
            key={article.id}
            style={{
              border: "1px solid #ccc",
              borderRadius: "8px",
              padding: "20px",
              margin: "20px auto",
              maxWidth: "1200px",
              background: "#fff"
            }}
          >
            <header style={{ marginBottom: "10px" }}>
              <span style={{
                background: "#eef",
                padding: "4px 8px",
                borderRadius: "4px",
                marginRight: "10px",
                fontWeight: "bold"
              }}>{article.type}</span>
              <span style={{ color: "#555", marginRight: "10px" }}>
                {new Date(article.date).toLocaleDateString()}
              </span>
              <span style={{ fontStyle: "italic", color: "#777" }}>
                by {article.author}
              </span>
            </header>
            <div className="article-flex">
              <div style={{ flex: "1 1 60%", lineHeight: "1.6" }}>
                {article.content.split("\n\n").map((para, i) => (
                  <p key={i} style={{ marginBottom: "1em" }}>{para}</p>
                ))}
              </div>
              <div className="article-image-wrapper">
                <img
                  src={article.image}
                  alt="Article"
                  style={{ maxWidth: "100%", borderRadius: "4px" }}
                />
              </div>
            </div>
          </article>
        ))
      }
    </div>
  );
};

export default ArticleFeatured;
